const env = require("services/env");
const {firstToUpper} = require("helpers/format");

class Enum {

    constructor(slug) {
        this.slug = slug;
    }

    get raw(){
        return env.get('enums.' + this.slug, {});
    }

    get options() {
        const options = this.raw;

        return Object.keys(options).map(option => ({
            label: firstToUpper(options[option]),
            value: option,
        }));
    }

    only(only = []){
        return this.options.filter(option => {
            return only.includes(option.value);
        });
    }

    except(except = []){
        return this.options.filter(option => {
            return !except.includes(option.value);
        });
    }

    label(value){
        let label = this.raw[value];
        if(typeof(label) === 'string'){
            label = firstToUpper(label);
        }
        if(typeof(label) === 'undefined'){
            return value;
        }
        return label;
    }

    static labelFromSlug(slug, value){
        return (new Enum(slug)).label(value);
    }

}

module.exports = Enum;
